import { styled } from '@/stitches.config';
import { Box } from '@components';

export const StyledCardSection = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
});

export const StyledAccentColor = styled(Box, {
  height: '8px',
  marginBottom: '$4',
  width: '$8',
});

export const StyledNoDataMessage = styled('span', {
  color: '$darkBlue300',
  fontSize: '$md',
  fontWeight: '$xbold',
  lineHeight: '20px',
});

export const StyledDisplayResults = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
});
